import { getLdsBoardBasisLabelHebrew } from "../../utils/ldsBoardBasisHebrew";

/**
 * Guest-facing meal basis. Known codes use the existing LDS/hotelBoardBasis map.
 * Text that is already Hebrew is left as-is. Unknown codes are not given a new Hebrew label.
 */
export function displayBoardBasisHe(raw) {
  const text = String(raw ?? "").trim();
  if (!text) return "";
  if (text.includes("·")) {
    const parts = text
      .split("·")
      .map((part) => displayBoardBasisHe(part))
      .filter(Boolean);
    return [...new Set(parts)].join(" · ");
  }
  if (/[\u0590-\u05FF]/.test(text)) return text;
  if (text.toUpperCase() === "BB") return "לינה וארוחת בוקר";
  const he = getLdsBoardBasisLabelHebrew(text);
  return he || text;
}
